import tinyColor from 'tinycolor2';
import { ChartColors } from '../../theme/tokens';

const deselectedColor = tinyColor(ChartColors[0])
  // @ts-ignore
  .greyscale(100)
  .toHexString();

export default deselectedColor;
